<!-- 口袋精灵 -->
<template>
  <div class="container">
    <div class="list">
      <template v-if="list.length">
        <div class="item" v-for="(item, index) in list" :key="index">
          <img :src="item.fairy.f_good_img" alt="" class="icon">
          <div class="info">
            <h1 class="name">{{item.d_name}}</h1>
            <h2 class="type">{{item.f_device}}</h2>
          </div>
          <div class="unbind" @click="unbind(item.f_id, item.f_device)">解绑</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getFairyDeviceList, unbindDevice } from '@/apiv4/fairy'
export default {
  components: {  },
  data() {
    return {
      list: [],
      total: 0,
    }
  },
  async created() {
    
  },
  mounted() {
    this.getFairyDeviceList()
  },
  methods: {
    async getFairyDeviceList() {
      let fairyListRes = await getFairyDeviceList()
      let list = fairyListRes.data.list
      this.list = list
      this.total = +fairyListRes.data.total
    },
    unbind(fId, device) {
      let check = confirm('确认要解除绑定吗？')
      if (!check) return
      unbindDevice(fId, device).then(() => {
        this.$toast.show({ text: '解绑成功！', duration: 2000 })
        this.getFairyDeviceList()
      }).catch(err => {
        this.$toast.show({ text: '解绑失败，请稍后再试', duration: 3000 })
      })
    }
  },
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";
.container {
  height: 100%;
  min-height: 100vh;
  background: #f4f4f8;
}

.list {
  .item {
    position: relative;
    display: flex;
    padding: 2.6vw 3.2vw;
    padding-right: 5.6vw;
    background: #fff;
    .icon {
      display: block;
      width: 16vw;
      height: 16vw;
      border: 1px solid rgba(0,0,0,0.1);
    }
    .info {
      flex: 1;
      padding-left: 3.2vw;
      .name {
        margin-bottom: 1.6vw;
        font-size: 4.8vw;
        color: #604038;
        font-weight: bold;
      }
      .type {
        font-size: 3.73vw;
        color: #9b9b9b;
        font-weight: normal;
      }
    }
    .unbind {
      display: block;
      align-self: center;
      font-size: 4.26vw;
      color: #9b9b9b;
    }
  }
}

</style>
